import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { menuCode } from '../../../shared/constants/Constants';
import { Routes } from '../../../../routes';

import { ListProducts } from '../../organisms';
import PSDynamicBasicTable from '../../PSDynamicBasicTable';
import PSLoading from '../../PSLoading';
import RenovationActions from '../../molecules/renovationActions/RenovationActions';
import RenovationStatus from '../../molecules/renovationStatus/RenovationStatus';
import PSIcon from '../../PSIcon';

import './index.scss';

const headerTable = [
  { elementProp: 'producto', headerColumn: 'Producto', clickable: true },
  { elementProp: 'nroPolicy', headerColumn: 'Póliza', clickable: true },
  { elementProp: 'rol', headerColumn: 'Rol', clickable: true },
  { elementProp: 'dateVigencia', headerColumn: 'Vigencia', clickable: true },
];

const headerVITable = [
  { elementProp: 'producto', headerColumn: 'Producto', clickable: true },
  { elementProp: 'nroPolicy', headerColumn: 'Póliza', clickable: true },
  { elementProp: 'nroCertificate', headerColumn: 'Número de certificado', clickable: true },
  { elementProp: 'rol', headerColumn: 'Rol', clickable: true },
  { elementProp: 'dateVigencia', headerColumn: 'Vigencia', clickable: true },
];

export default function ProductsByUser({
  listProducts,
  selectUserProduct,
  selectDetail,
  listPoliceByProducts,
  loading,
  loadingDetails,
  productSelected,
  beneficary,
  refreshProducts,
}) {
  const history = useHistory();
  const { administrator } = useSelector((state) => state.user);
  const authorizedRoles = ['1628723214', '1628723212']; // admin y apoyo soluciones de clientes

  const isAuthorizedRole = administrator.info?.roles.some((role) => authorizedRoles.includes(role));

  const customHeaderTable = () => {
    const productWithCertificate = [
      menuCode.VIDA_INDIVIDUAL,
      menuCode.DESGRAVAMEN,
      menuCode.ACCIDENTES_PERSONALES,
    ];
    if (productWithCertificate.includes(productSelected.menuId)) return headerVITable;

    // Solo para SOAT y roles autorizados mostramos 2 nuevos campos
    if (productSelected.menuId === menuCode.SOAT && isAuthorizedRole) {
      return [
        ...headerTable,
        {
          elementProp: 'renovacion',
          headerColumn: 'Renovación Automática',
          clickable: false,
          render: (item) => <RenovationStatus dataPolicy={item} />,
        },
        {
          elementProp: 'accion',
          headerColumn: 'Acción',
          clickable: false,
          render: (item) => (
            <RenovationActions dataPolicy={item} refreshProducts={refreshProducts} />
          ),
        },
      ];
    }
    return headerTable;
  };

  return !loading ? (
    <div className="container-products-user">
      <div className="general-title">
        <PSIcon
          type="arrowBack"
          className="icon-arrow-back"
          onClick={() => {
            history.push(`${Routes.NET_NATURAL_USER}`);
          }}
        />
        <div className="item-info-basic">
          <div>
            <h2 className="info-name">{beneficary.name}</h2>
            <div className="info-mail">
              {beneficary.tipoDoc} {beneficary.nroDoc}
            </div>
          </div>
        </div>
      </div>

      <div id="containerProductDetails" className="container-product-details">
        <div className="table-title">Productos Contratados</div>
      </div>

      <div className="container-user-products">
        {listProducts.length > 0 ? (
          <ListProducts
            listProducts={listProducts}
            selectProduct={selectUserProduct}
            productSelected={productSelected}
            className="products-by-user"
          />
        ) : (
          <p>El cliente no cuenta con productos vigentes</p>
        )}
      </div>
      {listProducts.length > 0 && productSelected && (
        <div id="containerProductDetails" className="container-product-details">
          <div className="table-title">Detalle del seguro</div>

          <PSDynamicBasicTable
            headers={customHeaderTable()}
            items={listPoliceByProducts}
            onSelect={selectDetail}
            loading={loadingDetails}
            productSelected={productSelected}
          />
        </div>
      )}
    </div>
  ) : (
    <div className="align-all-center">
      <PSLoading color="default" />
    </div>
  );
}
